import React, { useState } from 'react';
import { CommonButton } from '../../../../components';
import i18next from 'i18next';

export default function RefundPaymentMethodSelection({ onSelect, onCancel }) {
  const [selectedMethod, setSelectedMethod] = useState(null);

  const paymentMethods = [
    {
      key: 'check',
      label: i18next.t('text.report.check') || 'Check',
    },
    {
      key: 'finance',
      label: i18next.t('text.report.financing') || 'Financing',
    },
    {
      key: 'card',
      label: i18next.t('text.report.creditCard') || 'Credit Card',
    },
    {
      key: 'cash',
      label: i18next.t('text.report.cash') || 'Cash',
    },
  ];

  const handleMethodClick = (methodKey) => {
    setSelectedMethod(methodKey);
    onSelect(methodKey);
  };

  return (
    <div style={{ padding: '0', width: '100%' }}>
      <h4
        className="mb-3" 
        style={{ 
          fontWeight: 600, 
          fontSize: '18px',
          color: '#8c8c8c',
          textAlign: 'center',
          width: '100%',
          lineHeight: '1.5'
        }}
      >
        {/* {i18next.t('text.report.refundPaymentMethods')} */}
        Payment Methods
      </h4>
      <div 
        className="d-flex flex-column" 
        style={{ 
          gap: '10px', 
          marginBottom: '24px',
          width: '100%'
        }}
      > 
        {paymentMethods.map((method) => (
          <CommonButton
            key={method.key}
            type="button"
            className={`btn btn-lg w-100 ${
              selectedMethod === method.key 
                ? 'btn-primary' 
                : 'btn-outline-primary'
            }`}
            onClick={() => handleMethodClick(method.key)}
            style={{
              padding: '16px 24px',
              fontSize: '16px',
              fontWeight: 500,
              textAlign: 'center',
              borderWidth: '2px',
              borderRadius: '8px',
              transition: 'all 0.3s ease',
              minHeight: '56px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
            }}
          >
            {method.label}
          </CommonButton>
        ))}
      </div>
      <div 
        className="d-flex justify-content-end mt-4 pt-3" 
        style={{ 
          borderTop: '1px solid #e0e0e0',
          marginTop: '24px',
          paddingTop: '20px',
          width: '100%',
        }}
      >
        <CommonButton
          type="button"
          className="btn btn-secondary"
          onClick={onCancel}
          style={{
            minWidth: '110px',
            padding: '10px 24px',
            fontSize: '15px',
            fontWeight: 500,
            borderRadius: '6px',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center'
          }}
        >
          Cancel
        </CommonButton>
      </div>
    </div>
  );
}